export type DashboardVersion = 'NEW' | 'PREVIOUS';

export const DashboardVersions: Record<DashboardVersion, DashboardVersion> = {
  NEW: 'NEW',
  PREVIOUS: 'PREVIOUS',
};

/** A coluna nasce NULL para a base inteira, então este padrão é o que lança a versão nova sem UPDATE em massa. */
export const DEFAULT_DASHBOARD_VERSION: DashboardVersion =
  DashboardVersions.NEW;

export const isDashboardVersion = (value: unknown): value is DashboardVersion =>
  Object.values(DashboardVersions).includes(value as DashboardVersion);

/** `undefined` (backend sem a coluna), `null` (nunca escolheu) e valor extinto querem todos o padrão. */
export const resolveDashboardVersion = (value: unknown): DashboardVersion =>
  isDashboardVersion(value) ? value : DEFAULT_DASHBOARD_VERSION;

export type UpdateDashboardVersionDto = { dashboardVersion: DashboardVersion };

export type UpdateDashboardVersionResponse = {
  dashboardVersion: DashboardVersion;
};
